import {ButtonProps, ColorKeys} from "atmosfair-ui";
import {StringDisplayCalculationTierHintProps} from "./common/CalculationTierTooltipHint";
import {CSSProperties} from "react";
import {setJourneyHideLoadBundleInformation} from "../../../redux/reducer/journey";
import {setTravelComponentsHideLoadBundleInformation} from "../../../redux/reducer/travel-components";
import {AppDispatch} from "../../../redux/reducer/store";
import {WhereToDisplayActivityString} from "../../../utils/string/common";

export interface CommonActivityStringProps {
    textColor?: ColorKeys,
    truncatedWordsListMaxWidthPercentage?: number,
    whereToDisplay?: WhereToDisplayActivityString,
    shortEmissions?: boolean,
    journeyWithExactDates?: boolean,
    textClasses?: string | string[],
    textStyles?: CSSProperties,
    iconColor?: StringDisplayCalculationTierHintProps["iconColor"],
    hideAllIconHints?: boolean,
    iconSize?: ButtonProps["size"]
}

export interface CommonActivityWithReturnRouteProps {
    showReturnIcon: boolean
}

export const DEFAULT_TRUNCATED_WORDS_LIST_WIDTH_PERCENTAGE = 95

export const ICON_MARGIN = {marginTop: '5px'}


/**
 * Handles the onClick event for the string display associated with the footnote icon.
 * Depending on the specified display location (`whereToDisplay`), it dispatches relevant actions
 * to update the application state.
 *
 * @param {WhereToDisplayActivityString} whereToDisplay - The destination where the activity string will be displayed.
 * @param {AppDispatch} dispatch - The Redux dispatch function to trigger state updates.
 * @param {string} id - The unique identifier of the activity associated with the footnote.
 */
const onClickStringDisplayFootnoteIcon = (whereToDisplay: WhereToDisplayActivityString, dispatch: AppDispatch, id: string) => {
    if (typeof whereToDisplay === "undefined") return

    switch (whereToDisplay) {
        case WhereToDisplayActivityString.journey:
            dispatch(setJourneyHideLoadBundleInformation({activityId: id, value: true}))
            break;
        case WhereToDisplayActivityString.travelComponents:
            dispatch(setTravelComponentsHideLoadBundleInformation({activityId: id, value: true}))
            break;
        case WhereToDisplayActivityString.pdf:
            break;
        case WhereToDisplayActivityString.dropdownJourney:
            break;
        default:
            whereToDisplay satisfies never
    }
}